import request from '../request';

import {
  AIValidationResult,
  ApproveIncidentReportPayload,
  LaunchBOType,
  PatchIncidentReportPayload,
  PostIncidentReportPayload,
  Reservation,
  ReservationIncidentReport,
  ReservationIncidentReportParams,
} from './types';

const BASE_URL = 'reservations/reservation_incident_reports';

export const getReservationIncidentReportById = async (id: number) => {
  const { data } = await request.get<LaunchBOType>(`${BASE_URL}/${id}/`);
  return data;
};

export const getReservationIncidentReports = async (
  payload: ReservationIncidentReportParams,
): Promise<ReservationIncidentReport> => {
  const { data } = await request.get<ReservationIncidentReport>(`${BASE_URL}/`, {
    params: payload,
  });

  return { results: data.results, total_pages: data.total_pages, count: data.count };
};

export const getReservationById = async (id: string) => {
  const { data } = await request.get<Reservation>(`/reservations/${id}/summary`);
  return data;
};

export const patchReservationIncidentReport = async (
  id: number,
  payload: PatchIncidentReportPayload,
) => {
  const { data } = await request.patch<LaunchBOType>(`${BASE_URL}/${id}/`, payload);
  return data;
};

export const moveReservationIncidentReportToAnalysis = async (
  id: number,
  payload: PatchIncidentReportPayload | ApproveIncidentReportPayload,
) => {
  const { data } = await request.patch<LaunchBOType>(`${BASE_URL}/${id}/`, payload);
  return data;
};

export const postReservationIncidentReport = async (payload: PostIncidentReportPayload) => {
  const { data } = await request.post<LaunchBOType>(`${BASE_URL}/`, payload);
  return data;
};

export const deleteReservationIncidentReport = async (id: number) => {
  await request.delete(`${BASE_URL}/${id}/`);
};

export const approveReservationIncidentReport = async (
  id: number,
  payload: ApproveIncidentReportPayload,
) => {
  const { data } = await request.patch<LaunchBOType>(`${BASE_URL}/${id}/`, payload);
  return data;
};

export const validateBOWithAI = async (id: number): Promise<AIValidationResult> => {
  const { data } = await request.post<AIValidationResult>(`${BASE_URL}/${id}/ai-validate/`);
  return data;
};

export const acceptAISuggestion = async (id: number): Promise<void> => {
  await request.post(`${BASE_URL}/${id}/ai-suggestion-accepted/`);
};
